import ConversationDownload from './ConversationDownload.js';
import PhoneNumberFormat from './PhoneNumberFormat.js';
import FileDownload from './FileDownload.js';
import StringUtil from './StringUtil.js';
import PopupUtil from './PopupUtil.js';
import PasswordValidation from './PasswordValidation.js';
import UrlUtil from './UrlUtil.js';
import {dateToText} from '../../../../node_modules/uidev-component/grid/urDataGrid/util'

class AiccUtils {

  constructor() {
    this.conversationDownload = new ConversationDownload();
    this.phoneNumberFormat = new PhoneNumberFormat();
    this.fileDownload = new FileDownload();
    this.stringUtil = new StringUtil();
    this.popupUtil = new PopupUtil();
    this.passwordValidation = new PasswordValidation();
    this.urlUtil = new UrlUtil();
  }

  // data grid에서 사용할 사용자 정의 정렬 기능
  // 오름차순은 Null값이 최상단, 내림차순은 Null값이 최하단 위치
  sortNull = (x, y) => {
    if (!x && !y) return 0;
    if (!x) return -1;
    if (!y) return 1;

    if (x === y) return 0;
    if (x > y) return 1;
    return -1;
  }

  // 새 캠페인 작성창을 새로 띄운다.
  // modeValue 값 : 신규 작성('I'), 수정('U'), 복사('C')
  newOutCallSchedulePopup(modeValue, scheduleId, popupCloseHandler) {
    let url = `/popup.html#/PGE_AIC_00003?mode=${modeValue}`;
    const newWindowOptions = 'width=1280,height=860,location=no,menubar=no,status=no,toolbar=no,resizable=no';
    const centerPopupOption = aiccUtils.popupUtil.getCenterPopupOption(newWindowOptions);

    if (modeValue === 'U' || modeValue === 'UB' || modeValue === 'C') {
      url = url + `&scheduleId=${scheduleId}`;
    }
    let popupWin = window.open(window.location.pathname + url, '', centerPopupOption);
    // popupWin.addEventListener('beforeunload', popupCloseHandler);
    popupWin.addEventListener('unload', popupCloseHandler);
    return popupWin;
  }

  // URL 에 사용된 parameter를 분리하여 리턴한다.
  // 리턴하는 값 예시 : {mode: 'U', scheduleId: '5dd13f6f3faf49beaad00dcbd3c8b092'}
  getUrlParamMap(url) {
    let urlArry = url.split('?');
    if(urlArry.length < 2) return {};
    return _.chain(urlArry[1])
                .replace('?', '') // a=b454&c=dhjjh&f=g6hksdfjlksd
                .split('&') // ["a=b454","c=dhjjh","f=g6hksdfjlksd"]
                .map(_.partial(_.split, _, '=', 2)) // [["a","b454"],["c","dhjjh"],["f","g6hksdfjlksd"]]
                .fromPairs() // {"a":"b454","c":"dhjjh","f":"g6hksdfjlksd"}
                .value();
  }

  /**
   * 파일이 BOM(Byte Order Mark)으로 시작하는 파일인지 확인한다.
   * @param {file} file 
   * @param {function} bomCallback file이 BOM으로 시작되면 호출될 callback 함수
   * @param {function} notBomCallback file이 BOM으로 시작되지 않으면 호출될 callback 함수
   */
  checkBomInFile(file, bomCallback, notBomCallback) {
    /*
      UTF-8   EF BB BF (239 187 191)
      UTF-16 빅 엔디안    FE FF (254 255)
      UTF-16 리틀 엔디안  FF FE (255 254)
      UTF-32 빅 엔디안    00 00 FE FF (0 0 254 255)
      UTF-32 리틀 엔디안  FF FE 00 00 (255 254 0 0)
    */

    const reader = new FileReader();
    reader.onload = (rs) => {
      let filedata = rs.target.result;
      // console.log(filedata);

      const byte1 = filedata.charCodeAt(0);
      const byte2 = filedata.charCodeAt(1);
      const byte3 = filedata.charCodeAt(2);
      const byte4 = filedata.charCodeAt(3);

      // console.log("file bytes", byte1, byte2, byte3, byte4);
      
      if(
        (byte1 === 239 && byte2 === 187 && byte3 === 191)
        || (byte1 === 254 && byte2 === 255)
        || (byte1 === 255 && byte2 === 254)
        || (byte1 === 0 && byte2 === 0 && byte3 === 254 && byte4 === 255)
        || (byte1 === 255 && byte2 === 254 && byte3 === 0 && byte4 === 0)
        ) {
          if(bomCallback) {
            bomCallback();
          }
      }
      else {
        if(notBomCallback) {
          notBomCallback();
        }
      }
    }

    reader.readAsBinaryString(file);
  }

  /**
   * urDataGrid 내용을 CSV 파일로 저장한다.
   * 
   * uidev-component/grid/urDataGrid/mixin/com/urCommonGridExportMixin.js에서 mx_exportCsvData() 소스를 복사해서 만들었다.
   * 원본에서는 값 저장할 때 무조건 큰따옴표를 붙이므로 붙이지 않는 경우도 필요하여 큰따옴표 붙일지 여부를 파라미터로 지정하도록 하였다.
   * convert-csv-to-json 패키지를 쓸 때 sub array 처리를 위해 필드 값 앞뒤로 특정 문자를 붙여야 해서 이를 처리하는 것도 추가하였다.
   * 
   * @param {Object} grid urDataGrid
   * @param {string} csvFilename grid를 내용을 저장할 CSV 파일 이름
   * @param {boolean} withDoubleQuote 필드를 큰따옴표로 둘러싸서 저장할지 여부
   */
  dataGridToCsv(grid, csvFilename, withDoubleQuote, guideText) {
    let filename = csvFilename || 'dataExport.csv';
    let blob, csvUrl, a;
    let csvArray = [];

    // console.log(grid);

    // 1. set header
    // 가이드 문구 
    if (!utils.isEmpty(guideText)) {
      guideText.forEach(guide => {
        let row = [];
        row.push(guide);
        // 컴마가 들어가면 csv 에서 필드가 쪼개진다. 우선 빈 칸으로 바꾼다. 
        csvArray.push(row.map(r => { return r.replaceAll(',', ' ')}));
      });
    }

    // grid 헤더
    csvArray.push(grid.mx_fieldsInfo.map(f=>f.text||f.value));

    // 2. set Data
    let gridData = grid.mx_sharedData.gridData;

    csvArray = csvArray.concat(gridData.map(r => {
      return grid.mx_fieldsInfo.map(f => {
          var cv = f.customValue, v = r[f.value], rtn = v;
          if(cv && typeof cv ==='function') {
              rtn = cv(v, r);
          }
          switch(f.type) {
          case 'date':
              const opts = grid.mx_options;
              const fmt = f.dateFormat || opts.dateFormat;
              const timezone = f.timezone===null ? opts.timezone : f.timezone;
              rtn = dateToText(v, fmt, timezone);
              break;
          case 'code':
              if(f.__domainMap) {
                  var dobj = f.__domainMap.get(v);
                  rtn = dobj ? dobj.text : v;
              }
              break;
          case 'boolean':
          case 'number':
              rtn = v;
              break;
          default:
              rtn = v || "";
          }

          /*
            필드 값을 특정 문자열로 둘러쌀지 여부에 따라 처리
            npm 패키지 중에 convert-csv-to-json를 쓰면 배열인 경우 특정 문자로 둘러싸야 한다.
            data grid의 header를 설정할 때 enclosingString에 문자 또는 문자열을 지정하면 그 문자열로 필드 값을 둘러싼다.
            enclosingString 속성은 data grid에서 쓰지는 않지만 javascript 특정상 지정하면 지정된다.
            예를 들어 아래와 같이 data grid 헤더를 설정에 enclosingString를 큰따옴표로 지정했다면, runScriptOrder 값은 큰 따옴표로 둘러싸게 된다.
            withDoubleQuote가 true이면 역시 큰따옴표로 둘러싸게 되며도 withDoubleQuote 파라미터와 enclosingString 설정을 조화롭게 쓰도록 하자.
            
            csvDownLoadHeaders : [
              ...
              {value: 'runScriptOrder', text: '스크립트 순서', enclosingString: "\""},
            ],

            참고.
            https://www.npmjs.com/package/convert-csv-to-json
            https://github.com/iuccio/CSVtoJSON#generate-object-with-sub-array
          */

          if(f.enclosingString) {
            rtn = f.enclosingString + rtn + f.enclosingString;
          }

          // 필드 값을 큰따옴표로 둘러쌀지 여부에 따라 처리
          if(withDoubleQuote) {
            // 원본은 아래처럼 돼 있는데 이렇게 하면 처음은 큰따옴표 3개인데 끝은 2개로 끝나서 엑셀에서 제대로 읽히지 않음.
            // return '"'+ ((""+rtn).replace(/"/,'""')) +'"';
            // 큰따옴표를 제대로 escaping하려고 아래와 같이 바꾸었음.
            return '"'+ ((""+rtn).replace(/"/gi,'""')) +'"';
          }
          else {
            return rtn;
          }
      })
    }))

    console.log(JSON.stringify(csvArray));

    const BOM = "\uFEFF";
    var csvString = BOM + csvArray.map(r=>r.join(",")).join("\r\n");
    
    // IE 10, 11, Edge Run
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        blob = new Blob([decodeURIComponent(csvString)], {
            type: 'text/csv;charset=utf8'
        });
        window.navigator.msSaveOrOpenBlob(blob, filename);
    } else if (window.Blob && window.URL) {
        // HTML5 Blob
        blob = new Blob([csvString], { type: 'text/csv;charset=utf8' });
        csvUrl = URL.createObjectURL(blob);
        a = document.createElement('a');
        a.setAttribute('style', 'display:none');
        a.setAttribute('href', csvUrl);
        a.setAttribute('download', filename);
        document.body.appendChild(a);
        a.click()
        a.remove();
    } else {
        // Data URI
        var csvData = 'data:application/csv;charset=utf-8,' + encodeURIComponent(csvString);
        a = document.createElement('a');
        a.setAttribute('style', 'display:none');
        a.setAttribute('target', '_blank');
        a.setAttribute('href', csvData);
        a.setAttribute('download', filename);
        document.body.appendChild(a);
        a.click()
        a.remove();
    }
  }

  getStringByteSize(str){
    let totalByte = 0;
    if(str) {
      for(let ii = 0 ; ii < str.length ; ii++) {
        const currChar = str.charAt(ii);
        const uniCurrChar = escape(currChar);
        if(uniCurrChar.length > 4) {
          totalByte += 2;
        } else {
          totalByte += 1;
        }
      }
    }
    return totalByte;
  }

  sliceStringByByte(str, bytes){
    let b, i, c;
    for(b=i=0 ; c=str.charCodeAt(i);){
        b+=c>>7?2:1;
        if(b > bytes) {
            break;
        }
        i++;
    }
    return str.substring(0,i);
  }

  substringByByte(str, maxByte) {
    let totalByte = 0;
    let result = '';

    if(str) {
      for(let ii = 0 ; ii < str.length ; ii++) {
        const currChar = str.charAt(ii);
        const uniCurrChar = escape(currChar);
        if(uniCurrChar.length > 4) {
          totalByte += 2;
        } else {
          totalByte += 1;
        }
  
        if(totalByte > maxByte){
          result = str.substring(0,ii);
          break;
        }
      }
    }
  
    return result;
  }
  
}



// const utils = new Utils();
// window.utils = utils;
export default AiccUtils;